import styles from "./buildingFlatNumber.module.scss";
import {useState} from "react";
import {Input} from "antd";

interface BuildingFlatNumberFormComponentProps {
    onChange?: (buildingAndFlatNumber: buildingAndFlat | null) => void,
    initialValues?: buildingAndFlat | null;
}

export interface buildingAndFlat {
    building: string | null,
    flat: string | null;
}

export default function BuildingFlatNumber(props: BuildingFlatNumberFormComponentProps) {
    const [buildingNumber, setBuildingNumber] = useState<string>(props.initialValues?.building ?? "");
    const [flatNumber, setFlatNumber] = useState<string>(props.initialValues?.flat ?? "");

    const onChange = (building: string | null, flat: string | null) => {
        props.onChange?.({
            building: building,
            flat: flat,
        });
    };

    return <div className={styles.inputContainer}>
        <Input
            value={buildingNumber}
            placeholder={"Numer budynku..."}
            onChange={e => {
                setBuildingNumber(e.target.value);
                onChange(e.target.value, flatNumber);
            }}
        />
        <span>/</span>
        <Input
            placeholder={"Numer mieszkania..."}
            value={flatNumber}
            onChange={e => {
                setFlatNumber(e.target.value);
                onChange(buildingNumber, e.target.value);
            }}
        />
    </div>
}